import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IoShareOutline } from "react-icons/io5";
import { IoSearchOutline } from "react-icons/io5";
import { CiSearch } from "react-icons/ci";
import MerchantHistory from './MerchantHistory';
import ShopbyCategory from './ShopbyCategory';
import NitroAd from './NitroAd';
import ShopbyActivity from './ShopbyActivity';
import BestOfMerchant from './BestOfMerchant';
import MeetBigCats from './MeetBigCats';
import BottomFooterImages from './BottomFooterImages';
import SharePage from './SharePage';
import { FaArrowLeftLong } from "react-icons/fa6";
import { IoShareSocialOutline } from "react-icons/io5";
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const MerchantSiteNav = () => {
    const [merchantSiteNavsearch,setMerchantSiteNavsearch] = useState('')
    const [logoData, setLogoData] = useState(null);
    const [merchantData, setMerchantData] = useState(null);
    const [allCategory,setAllCategory] = useState([]);
    const [firstThreeCategory,setFirstThreeCategory] = useState([]);
    const [categoryId,setCategoryId] = useState("")

    const {merchantid} = useParams()

    useEffect(() => {
      if (!merchantid) return; // avoid firing with undefined
      axios.get(`https://api.bakpoket.com/api/MerchantCategories?merchantId=${merchantid}&onlyActive=true`)
        .then(res => {setAllCategory(res.data)
        })
        .catch(err => console.log("err", err));
    }, [merchantid]);

    useEffect(() => {
      setMerchantData(merchantid)
    }, []);

    useEffect(()=>{
      setFirstThreeCategory(allCategory.slice(0, 3));
      // console.log("firstThreeCategory",firstThreeCategory)
    },[allCategory])

    useEffect(() => {
      if (merchantData) {
        axios
          .get(`https://api.bakpoket.com/api/MerchantPage/GetMerchantStore/${merchantData}`)
          .then((res) => {
            setLogoData(res.data);
          })
          .catch((err) => console.log(err));
      }
    }, [merchantData]); 

    const handilingsubmit=(e)=>{
      e.preventDefault()
      // console.log(merchantSiteNavsearch)
    }

    const showsearch = ()=>{
      var showsearch = document.getElementById("showsearch");
      var hidesearch = document.getElementById("hidesearch");
      showsearch.classList.add("hide-searchbar")
      hidesearch.classList.remove("hide-searchbar")
    }

    const hidesearch =()=>{
      var showsearch = document.getElementById("showsearch");
      var hidesearch = document.getElementById("hidesearch");
      showsearch.classList.remove("hide-searchbar")
      hidesearch.classList.add("hide-searchbar")
    }

    const share = () =>{
      if(navigator.share){
        navigator.share({
          text :'Checkout this cool website!',
          url:''
        })
      } else{
        navigator.clipboard.writeText('code we want tocopy')   
      }
    }

    const dumycategory=[
      {id:1,categoryName:"category1"},
      {id:2,categoryName:"category2"},
      {id:3,categoryName:"category3"},
    ]
    

    useEffect(()=>{
      axios.get(`https://api.bakpoket.com/api/merchantpage/efq/products?merchantId=${merchantid}&categoryId=${categoryId}&approvedOnly=false&includeImages=true`)
      .then(res => {
        // console.log(res.data)
      })
      .catch(err => console.log(err))
    },[categoryId])


  return (
    <>
      <Wrapper>
        <div className="container py-2" id='showsearch'>
          <div className='d-none d-md-block'>
            <div className='row py-2 py-lg-0'>
              <div className='col-lg-1 col-md-1 col-sm-2 col-3 py-2'>
                {logoData ? <img src={`data:image/jpeg;base64,${logoData?.merchantLogo}`} className='img-fluid' alt="logo" /> :<img src='/images/logo.jpg' className='img-fluid' alt="logo" />}
              </div>
              <div className='col-md-7 col-4 p-0 my-auto'>
                <p className='fw-bold mb-1'>
                  {logoData?.storeName || "Brand"}
                </p>

                <div className='d-flex align-items-center'>
                  <span className="badge rounded-pill me-2 px-3" style={{backgroundColor:"#ef4766",cursor:"pointer"}}>Follow</span>
                  
                  <IoShareOutline className="fs-5 ms-1" onClick={()=>share()} style={{cursor:"pointer"}}/>
                  <div className='ms-4 d-flex gap-lg-3 gap-md-2'>
                    {firstThreeCategory && firstThreeCategory.length > 0 ? (
                      firstThreeCategory.map((cat)=>(
                        <p className='my-auto ' key={cat.id} onClick={() =>{setCategoryId(cat.id)}} style={{cursor:"pointer"}} >{cat.categoryName}</p>
                      ))
                    ):(
                      dumycategory.map((cat)=>(
                        <p className='my-auto ' key={cat.id} style={{cursor:"pointer"}} >{cat.categoryName}</p>
                      ))
                    )}
                    

                    {allCategory.length >= 3 ? 
                     <p className='my-auto' style={{cursor:"pointer"}} data-bs-toggle="offcanvas"
                    data-bs-target="#demo"
                    aria-controls="demo">more...</p>
                    :""}
                  </div>
                </div>
              </div>
              <div className='col-5 col-sm-6 col-md-3  my-auto hidded text-end'>
                  <form 
                  onSubmit={handilingsubmit}  
                  className="d-inline-flex align-items-center"
                  >
                  <button 
                      type="submit"
                      className="d-flex justify-content-center align-items-center bg-none border-1 border-end-0 rounded-start-5 py-1"
                      style={{ backgroundColor: "#fff", width: "40px", height: "40px" }}
                  >
                      <IoSearchOutline />
                  </button>

                  <input 
                      type='search'
                      placeholder="Search All Brand" 
                      className="border-1 border-start-0 text-decoration-none rounded-end-5 ps-1 pe-2"
                      style={{ outline: "none", height: "40px" }}
                      onChange={(e) => setMerchantSiteNavsearch(e.target.value)}
                  />
                  </form>

              </div>
              <div className="col-5 col-sm-6 col-md-9 text-end my-auto hide-search">
                  <div className="d-flex justify-content-end align-items-center">
                      <button 
                      type="submit" 
                      className="d-flex justify-content-center align-items-center border-1 py-1"
                      style={{ backgroundColor: "#fff", width: "30px", height: "30px" }}
                      onClick={()=>showsearch()}
                      >
                      <CiSearch />
                      </button>
                  </div>
              </div>
            </div>
          </div>

          <div className="container sticky-top p-0 ">
            <div className="col-12 hide-search">
              <nav className="navbar navbar-expand-lg navbar-light">
                <div className="d-flex align-items-center">
                  <button
                    className="navbar-toggler border-0 p-0 d-flex justify-content-center align-items-center"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#demo"
                    aria-controls="demo"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <span className="navbar-toggler-icon " style={{fontSize:'1rem'}}></span>
                  </button>

                  <button 
                    type="submit" 
                    className="border-0 d-flex justify-content-center align-items-center p-0"
                    style={{ width: "40px", height: "40px", backgroundColor: "#fff", fontSize: "1.2rem" }}
                    onClick={() => showsearch()}
                  >
                    <CiSearch />
                  </button>
                </div>


                <div className="d-flex align-items-center">
                  <span className="badge rounded-pill me-0 px-3" style={{backgroundColor:"#ef4766",cursor:"pointer"}}>Follow</span>
                  <button 
                    type="submit" 
                    className="border-0 d-flex justify-content-center align-items-center "
                    style={{ width: "40px", height: "40px", backgroundColor: "#fff", fontSize: "1.2rem" }}
                    onClick={() => share()}
                  >
                    <IoShareSocialOutline />
                  </button>
                </div>
                <div className="collapse navbar-collapse justify-content-end d-none d-lg-block">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <a className="nav-link active" href="/">Home</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/about">About Us</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/contact">Contact Us</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/footer">Footer</a>
                    </li>
                  </ul>
                </div>
              </nav>

              
            </div>
            <div className="offcanvas offcanvas-start" tabIndex="-1" id="demo" style={{zIndex:'1000'}}>
                <div className="offcanvas-header">
                  <h5 className="offcanvas-title">Shop by Category</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="offcanvas-body ps-4 ps-sm-5">
                  <ul className="navbar-nav">
                    {allCategory && allCategory.length >0 ?(
                      allCategory.map((cat) => (
                        <li className="nav-item" key={cat.id}>
                          <a
                              className="nav-link"
                              data-bs-dismiss="offcanvas"
                              onClick={() =>{setCategoryId(cat.id)}}
                              style={{cursor:"pointer"}}
                            >
                              {cat.categoryName}
                          </a>
                        </li>
                      ))
                    ):(
                      dumycategory.map((cat)=>(
                        // <p className='my-auto ' key={cat.id} style={{cursor:"pointer"}} >{cat.categoryName}</p>
                        <li className="nav-item" key={cat.id}>
                          <a
                              className="nav-link"
                              data-bs-dismiss="offcanvas"
                              style={{cursor:"pointer"}}
                            >
                              {cat.categoryName}
                          </a>
                        </li>
                      ))
                    )}
                    
                  </ul>

                </div>
              </div>
          </div>
        </div>

        <div className='container py-2 hide-searchbar' id='hidesearch'>
          <div className='row p-2'>
            <div className='col-12 d-flex'>
              <button 
                    
                    className="d-flex justify-content-center align-items-center bg-none border-1 border-end-0 rounded-start-1 py-1"
                    style={{ backgroundColor: "#fff", width: "40px", height: "40px" }}
                    onClick={()=>hidesearch()}
                  >
                    <FaArrowLeftLong />
                  </button>
              <form 
                  onSubmit={handilingsubmit}  
                  className="d-flex align-items-center w-100"
                >
                  <input 
                    placeholder="Search All" 
                    className="border-1 border-start-0 text-decoration-none rounded-end-1 ps-1 pe-3 flex-grow-1"
                    style={{ outline: "none", height: "40px" }}
                    onChange={(e) => setMerchantSiteNavsearch(e.target.value)}
                    type="search"
                  />
                </form>
            </div>
          </div>
        </div>
      </Wrapper>

      <ShopbyCategory categoryId={categoryId} merchantSiteNavsearch={merchantSiteNavsearch}/>
      <MeetBigCats/>
      <NitroAd/>
      <SharePage/>
      
      </>
  )};
const Wrapper = styled.div`
  position: sticky;
  top: 60px;
  z-index:60 ;
  background: white;
  border-bottom: 0.25rem solid #ddd;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  .hide-search{
    display:none !important;
  }

  .hidded{
    display:block !important;
  }

  .hide-searchbar{
    display:none
  }


  @media(max-width:767px){
    .hidded{
        display:none !important;
    }

    .hide-search{
        display:block !important;
    }
  }

  .modal-backdrop.fade {
    opacity: 0 !important;
  }

  .modal-backdrop{
    display:none;
  }

  .offcanvas{
    width: 240px;
    @media(min-width:576px){
      width: 360px;
    }
  }
`;

export default MerchantSiteNav;